$( document ).ready(function() {
    $('.mak-testi-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        arrows: true,
        dots: true,
        prevArrow: `<svg class="prev slick-prev mak__prev" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.56982 6.42993L3.49982 12.4999L9.56982 18.5699" stroke="#332D27" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.5 12.5H3.67" stroke="#332D27" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        nextArrow: `<svg class='next slick-next mak__next' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.4302 6.42993L20.5002 12.4999L14.4302 18.5699" stroke="#332D27" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 12.5H20.33" stroke="#332D27" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        responsive: [
    
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 1,
                 
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 1,
                  
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                  

                }
            }
        ]
    });

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".tab__btn");
    const contents = document.querySelectorAll(".new__tab-content");

    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        // Remove active classes
        buttons.forEach((b) => b.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        // Activate clicked tab and corresponding content
        this.classList.add("active");
        const tabId = this.getAttribute("data-tab");
        const contentToShow = document.querySelector(`.new__tab-content[data-tab="${tabId}"]`);
        if (contentToShow) {
          contentToShow.classList.add("active");
        }
      });
    });

    // Activate first tab by default
    if (buttons.length > 0) {
      buttons[0].click();
    }
  });
 
  // =======================
  // 1. Product Highlight Slider
  // =======================
  $('.product-highlight-main').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.custom-prev-2'),
    nextArrow: $('.custom-next-2'),
    infinite: true,
    speed: 750,
    autoplay: true,
     pauseOnHover:false,
    autoplaySpeed: 4000,
    fade: true,
    cssEase: 'linear',
  });

  // =======================
  // 2. Toggle Button for Content Show/Hide
  // =======================
  $(".toggle-btn").on("click", function () {
    let wrapper = $(this).closest(".toggle-wrapper");
    let content = wrapper.find(".toggle-content");

    if (wrapper.hasClass("active")) {
      wrapper.removeClass("active");
      content.stop(true, true).slideUp(300); 
    } else {
      wrapper.addClass("active");
      content.stop(true, true).slideDown(300); 
    }
  });
  });
  document.addEventListener("DOMContentLoaded", function() {
  function initMultiSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.multi-slider').hasClass('slick-initialized')) {
        $('.multi-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.multi-slider').hasClass('slick-initialized')) {
        $('.multi-slider').slick('unslick');
      }
    }
  }

  initMultiSlider();

  window.addEventListener('resize', function() {
    initMultiSlider();
  });
});